import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  ResendVerifationCodeForRecoveryEmailMutation,
  ResendVerifationCodeForRecoveryEmailMutationVariables,
} from './__generated__/useResendVerificationCodeForRecoveryEmail.graphql.ts';

const RESEND_VERIFICATION_CODE_FOR_RECOVERY_EMAIL = gql`
  mutation ResendVerifationCodeForRecoveryEmailMutation(
    $input: resendVerificationCodeInput!
  ) {
    resendVerificationCode(input: $input) {
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  ResendVerifationCodeForRecoveryEmailMutation,
  ResendVerifationCodeForRecoveryEmailMutationVariables
>;

export const useResendVerificationCodeForRecoveryEmail = () => {
  const [mutate, { loading }] = useMutation(
    RESEND_VERIFICATION_CODE_FOR_RECOVERY_EMAIL,
    {
      showErrorsWithSnackNotification: true,
    }
  );

  const resendVerificationCodeForRecoveryEmail = useCallback(
    async (reference: string) => {
      const input = {
        reference,
      };
      const result = await mutate({
        variables: {
          input,
        },
      });
      return result;
    },
    [mutate]
  );

  return {
    resendVerificationCodeForRecoveryEmail,
    loading,
  };
};
